import React from "react";

const AboutAchievementSection = ({ data }) => (

    <section
        className="student-achievements-section"
        id="achievements"
    >

        <div className="container">

            <div className="student-section-header">

                <span className="student-eyebrow">
                    {data.eyebrow}
                </span>

                <h2>
                    {data.title}
                    <span>{data.highlight}</span>
                </h2>

                <p>
                    {data.description}
                </p>

            </div>


            <div className="achievement-highlight-grid">

                {(data.achievements || []).map((item, i) => (

                    <article
                        className="achievement-highlight-card"
                        key={i}
                    >

                        <div className="achievement-rank">
                            {item.year}
                        </div>


                        <div className="achievement-info">

                            <span className="achievement-program">
                                ACHIEVEMENT
                            </span>

                            <h3>
                                {item.title}
                            </h3>

                            <p>
                                {item.description}
                            </p>

                            {item.link && (
                                <a
                                    href={item.link.url}
                                    className="student-link"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {item.link.label}
                                </a>
                            )}

                        </div>

                    </article>

                ))}

            </div>

        </div>

    </section>
);

export default AboutAchievementSection;